export default {
  /**
   * 建築意匠図
   */
  ARCHITECTURAL_DESIGN_DRAWINGS: {
    name: 'ARCHITECTURAL_DESIGN_DRAWINGS',
    displayName: '建築意匠図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
      'STEEL_FLAME': {
        name: 'STEEL_FLAME',
        displayName: '鉄骨造が得意',
      },
      'REINFORCED_CONCRETE': {
        name: 'REINFORCED_CONCRETE',
        displayName: 'RC造が得意',
      },
      'WOODEN': {
        name: 'WOODEN',
        displayName: '木造が得意',
      },
      'FLOOR_PLAN_DETAIL': {
        name: 'FLOOR_PLAN_DETAIL',
        displayName: '平面図、その他基本情報から平面詳細図を起こせる',
      },
      'SECTION_DETAIL': {
        name: 'SECTION_DETAIL',
        displayName: '平面図・立面図・断面図、その他基本情報から断面詳細図を起こせる',
      },
    }
  },

  /**
   * 建築構造図
   */
  BUILDING_STRUCTURE_DRAWINGS: {
    name: 'BUILDING_STRUCTURE_DRAWINGS',
    displayName: '建築構造図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
      'STEEL_FLAME': {
        name: 'STEEL_FLAME',
        displayName: '鉄骨造が得意',
      },
      'REINFORCED_CONCRETE': {
        name: 'REINFORCED_CONCRETE',
        displayName: 'RC造が得意',
      },
      'WOODEN': {
        name: 'WOODEN',
        displayName: '木造が得意',
      },
      'VALIDATE_PLAN': {
        name: 'VALIDATE_PLAN',
        displayName: '伏図と軸組図の整合チェックができる',
      },
      'STEEL_FLAME_DETAIL': {
        name: 'STEEL_FLAME_DETAIL',
        displayName: '伏・軸・リスト、その他基本情報からおおよその鉄骨詳細図・鉄筋詳細図を起こせる',
      },
      'FRAMING_ELEVATION': {
        name: 'FRAMING_ELEVATION',
        displayName: '電算データのアウトプットからおおよその伏図・軸組図を起こせる',
      },
    }
  },

  /**
   * 建築設備図
   */
  BUILDING_FACILITIES_DRAWINGS: {
    name: 'BUILDING_FACILITIES_DRAWINGS',
    displayName: '建築設備図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
      'HYGIENE': {
        name: 'HYGIENE',
        displayName: '衛生・空調が得意',
      },
      'ELECTRICITY': {
        name: 'ELECTRICITY',
        displayName: '電気が得意',
      },
      'MACHINE_AND_PIPE': {
        name: 'MACHINE_AND_PIPE',
        displayName: '建築図・構造図と照らし合わせて機器配置・配管経路などの干渉チェックができる',
      },
    }
  },

  /**
   * 建築施工図
   */
  BUILDING_CONSTRUCTION_DRAWINGS: {
    name: 'BUILDING_CONSTRUCTION_DRAWINGS',
    displayName: '建築施工図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
      'STEEL_FLAME': {
        name: 'STEEL_FLAME',
        displayName: '鉄骨造が得意',
      },
      'REINFORCED_CONCRETE': {
        name: 'REINFORCED_CONCRETE',
        displayName: 'RC造が得意',
      },
      'WOODEN': {
        name: 'WOODEN',
        displayName: '木造が得意',
      },
      'FLOOR_PLAN_DETAIL': {
        name: 'FLOOR_PLAN_DETAIL',
        displayName: '建築図から平面詳細図を起こせる',
      },
      'BUILDING_FLAME': {
        name: 'BUILDING_FLAME',
        displayName: '構造図から躯体図を起こせる',
      },
      'BAR_ARRANGEMENT_DETAIL': {
        name: 'BAR_ARRANGEMENT_DETAIL',
        displayName: '構造図・躯体図から配筋詳細図を起こせる',
      },
    }
  },

  /**
   * 鉄骨製作図
   */
  STEEL_FRAME_FABRICATION_DRAWINGS: {
    name: 'STEEL_FRAME_FABRICATION_DRAWINGS',
    displayName: '鉄骨製作図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
      'STEEL_GENERAL': {
        name: 'STEEL_GENERAL',
        displayName: '構造図から鉄骨一般図を起こせる',
      },
      'EFFICIENCY': {
        name: 'EFFICIENCY',
        displayName: '製作時の作業性を考慮してディテールを描ける',
      },
    }
  },

  /**
   * 土木図
   */
  CIVIL_ENGINEERING_DRAWINGS: {
    name: 'CIVIL_ENGINEERING_DRAWINGS',
    displayName: '土木図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
    }
  },

  /**
   * 機械図
   */
  MECHANICAL_DRAWINGS: {
    name: 'MECHANICAL_DRAWINGS',
    displayName: '機械図が得意',
    children: {
      'OVER_FIVE_YEARS': {
        name: 'OVER_FIVE_YEARS',
        displayName: '実務経験5年以上',
      },
    }
  },
};